/*
 *
 * AdminManageUsers constants
 *
 */

export const PROCESSING = 'app/AdminManageUsers/PROCESSING';
export const GET_ADMIN_USERS = 'app/AdminManageUsers/GET_ADMIN_USERS';
export const GET_ADMIN_USERS_RESULT =
  'app/AdminManageUsers/GET_ADMIN_USERS_RESULT';
export const UPDATE_USER_ROLE = 'app/AdminManageUsers/UPDATE_USER_ROLE';
export const UPDATE_USER_ROLE_RESULT =
  'app/AdminManageUsers/UPDATE_USER_ROLE_RESULT';
export const GET_VALID_BRANDS = 'app/AdminManageUsers/GET_VALID_BRANDS';
export const GET_VALID_BRANDS_RESULT =
  'app/AdminManageUsers/GET_VALID_BRANDS_RESULT';
